export const credit = "credit";
export const paymentsWays = [
  [credit, "クレジットカード"],
  ["docomo", "キャリア決済(ドコモ)"],
  ["auone", "キャリア決済(au)"],
  ["softbank2", "キャリア決済(ソフトバンク)"],
  ["applepay", "Apple Pay"],
  ["recruit", "リクルートかんたん支払い"]
];

export const maxDescriptionLength = 120;
export const subscriptions = {
  'free': '',
  'com.globeejp.abceed.premium.monthly': '¥360/1ヶ月',
  'com.globeejp.abceed.premium.3month': '¥720/3ヶ月（¥240/1ヵ月）',
  'com.globeejp.abceed.premium.yearly': '¥2400/1年（¥200/1ヵ月）',
};

export const yadokari_home_product_id = "com.globeejp.abceed.contents.yadokari_moshi_home";
export const yadokari_event_product_id = "com.globeejp.abceed.contents.yadokari_moshi_event";
export const subscriptions_prefix = "com.globeejp.abceed.premium.";
export const unlimited_subscriptions_prefix = "com.globeejp.abceed.";
export const creditsBrands = {
  J: 'JCB',
  V: 'Visa',
  M: 'Master',
  A: 'AMEX',
  D: 'Diners',
  X: 'その他'
};
export const merchantId = '72994';
export const serviceId = '001';
export const categoryTDK = {
  'category_word': {
    title: '単語帳 - ジャンル | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: '単語帳 - ジャンル',
    description: '「金フレ」「デルボ」など、TOEIC有名教材がスマホアプリで学習できる！abceed上で学習できるTOEIC単語帳はこちら',
    keywords: 'toeic,abceed,globee,単語帳'
  },
  'category_grammer': {
    title: '文法対策 - ジャンル | abceed analytics（No.1 TOEIC教材アプリ）',
    headerTitle: '文法対策 - ジャンル',
    description: '「でる1000」「文法特急」など、TOEIC有名教材がスマホアプリで学習できる！abceed上で学習できるTOEIC文法問題集はこちら',
    keywords: 'toeic,abceed,globee,文法'
  },
  'category_mockexam': {
    title: '模試対策 - ジャンル | abceed analytics（No.1 TOEIC教材アプリ）',
    headerTitle: '模試対策 - ジャンル',
    description: '「至高の模試」「精選模試」など、TOEIC有名教材がスマホアプリで学習できる！abceed上で学習できるTOEIC模試はこちら',
    keywords: 'toeic,abceed,globee,模試'
  },
  'category_listening': {
    title: 'リスニング対策 - ジャンル | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: 'リスニング対策 - ジャンル',
    description: '「サラリーマン特急 新形式リスニング」「でる600」「パート3・4特急」など、TOEIC有名教材がスマホアプリで学習できる！abceed上で学習できるTOEICリスニング問題集はこちら',
    keywords: 'toeic,abceed,globee,リスニング'
  },
  'category_reading': {
    title: '読解対策 - ジャンル | abceed analytics（No.1 TOEIC教材アプリ）',
    headerTitle: '読解対策 - ジャンル',
    description: '「読解特急」「パート6特急」など、TOEIC有名教材がスマホアプリで学習できる！abceed上で学習できるTOEIC読解問題集はこちら',
    keywords: 'toeic,abceed,globee,リーディング,読解'
  },
  'category_summary': {
    title: '総合対策 - ジャンル | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: '総合対策 - ジャンル',
    description: '「全パート総合対策」「入門特急」など、TOEIC有名教材がスマホアプリで学習できる！abceed上で学習できるTOEIC読解問題集はこちらabceed analytics上で学習できるTOEIC総合対策はこちら',
    keywords: 'toeic,abceed,globee,総合対策'
  },
};



// WEBPACK FOOTER //
// ./src/constants.js